import { render, staticRenderFns } from "./AutoResetPassword.vue?vue&type=template&id=5fc56e88&scoped=true"
import script from "./AutoResetPassword.vue?vue&type=script&lang=js"
export * from "./AutoResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc56e88",
  null
  
)

export default component.exports